'use client'

import Typography from '@mui/material/Typography'
import { FC } from 'react'
import GridContainer from '../../../shared/components/GridContainer'
import { colors } from '../../../shared/theme/colors'

const MissionStatementSection: FC = () => (
  <section className="bg-green-900 py-24">
    <GridContainer>
      <div className="col-span-full flex flex-col items-center gap-6 text-center">
        <Typography variant="h4" sx={{ color: colors.White }}>
          Mission Statement
        </Typography>
        <Typography variant="h2" sx={{ color: colors.White }}>
          Empowering people to unlock financial progress
        </Typography>
      </div>
    </GridContainer>
  </section>
)

export default MissionStatementSection
